import React from 'react'
import ic04 from '../assets/svg/404/404.svg'

export default function NotFound() {
  return (
    <>
      <div className='align-items-center justify-content-center'>
        <div className='text-center p-5'>
          <h1 className='display-3 fw-bold'>Page Not Found</h1>
          <div className='lead mt-3'>
            <img src={ic04} alt="" />
          </div>
        </div>
      </div>
    </>
  )
}
